import {
  acceptHotItemStore,
  defineItemStore,
  useStoreItem
} from "@editor/items/itemStore.store";

import type { AreaItem } from "./AreaItem";

const itemStructure: AreaItem = {
  type: "area",
  id: 0,
  uid: "area_0",

  title: "",
  x: 0,
  y: 0,
  width: 0,
  height: 0,

  sceneId: 0,

  docs: {},
  createdAt: -1
};

export const useAreaStore = defineItemStore("model/areas", itemStructure, {
  getters: {
    /**
     * pass in a rectangle, return the area with the most overlap:
     */
    getByOverlap() {
      return (rect: {
        left: number;
        top: number;
        right: number;
        bottom: number;
      }) => {
        const allAreas = this.orderedItems;
        const areas = allAreas.map((area) => {
          return {
            id: area.id,
            left: area.x,
            right: area.x + area.width,
            top: area.y,
            bottom: area.y + area.height
          };
        });

        // loop through all the areas, save the largest overlap.
        let areaWithMostOverlap: (typeof rect & { id: number }) | null = null;
        let largestOverlap = 0;
        for (const area of areas) {
          const x_overlap = Math.max(
            0,
            Math.min(rect.right, area.right) - Math.max(rect.left, area.left)
          );
          const y_overlap = Math.max(
            0,
            Math.min(rect.bottom, area.bottom) - Math.max(rect.top, area.top)
          );
          const overlapArea = x_overlap * y_overlap;
          if (overlapArea > largestOverlap) {
            largestOverlap = overlapArea;
            areaWithMostOverlap = area;
          }
        }

        if (areaWithMostOverlap == null) return null;
        return this.byId[areaWithMostOverlap.id];
      };
    }
  }
});

export const useArea = useStoreItem(
  itemStructure,
  useAreaStore,
  (area, store) => {
    return {};
  }
);

if (import.meta.hot) {
  import.meta.hot.accept(acceptHotItemStore(useAreaStore, import.meta.hot));
}
